import React from 'react';
import PropTypes from "prop-types";

const InputForm = (props) => {
    const handleChangeSoloNumeros = (e, myFunction) => {
        const newValue = e.target.value;
        if (/^\d*$/.test(newValue)) {
            myFunction(e);
        }
    };

    const handleChangeSoloNumerosConDecimales = (e, myFunction) => {
        const newValue = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(newValue)) {
            myFunction(e);
        }
    };

    const handleImageUpload = (e, myFunction) => {
        const file = e.target.files[0];
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
        
        if (file && validImageTypes.includes(file.type)) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // Create a new file-like object with base64 data
                const base64File = {
                    ...file,
                    base64: reader.result,
                    originalFile: file
                };
                
                myFunction({
                    target: {
                        name: e.target.name,
                        type: e.target.type,
                        files: base64File
                    }
                });
            };
            
            // Read the file as base64
            reader.readAsDataURL(file);
        } else {
            alert('Por favor, selecciona un archivo de imagen válido (JPEG, PNG, GIF, WebP, SVG)');
            e.target.value = ''; // Clear the file input
        }
    };

    const handleChange=(e)=>{
        if(props.esNumero){
            handleChangeSoloNumeros(e,props.change)
        }
        else if(props.esNumeroConDecimales){
            handleChangeSoloNumerosConDecimales(e,props.change)
        }
        else if(props.type === 'file'){
            handleImageUpload(e,props.change)
        }
        else if(props.change){
            props.change(e)
        }
        else{
            return null
        }
    }

    return (
        <div className={props.col || 'col-12'}>
            <div className="mb-20">
                <label
                    htmlFor={props.name}
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                    {props.label} {props.required && <span className="text-danger-600">*</span>}
                </label>
                {props.type === 'textarea' ? (
                    <textarea
                        name={props.name}
                        className={`form-control radius-8 ${props.error?.[props.name] ? 'is-invalid' : ''}`}
                        placeholder={props.placeholder || ''}
                        onChange={handleChange}
                        value={props.datos ? props.datos[props.name] || '' : ''}
                        required={props.required}
                        rows={props.rows || 4}
                        style={{
                            lineHeight: props.lineHeight || 1.5,
                        }}
                    />
                ) : (
                    <input
                        name={props.name}
                        type={props.type || 'text'}
                        className={`form-control radius-8 ${props.error?.[props.name] ? 'is-invalid' : ''}`}
                        placeholder={props.placeholder || ''}
                        onChange={handleChange}
                        value={props.datos ? props.datos[props.name] || '' : ''}
                        required={props.required}
                        style={{
                            lineHeight: props.lineHeight || 1.5,
                        }}
                    />
                )}
                <div className="invalid-feedback">
                    {props.error?.[props.name]}
                </div>
            </div>
        </div>
    );
};

export default InputForm;

InputForm.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};